import React from "react";
import CommonDataTable from "../../../../components/Datatable/CommonDataTable";
import Badge from "../../../../components/Common/Badge";
import DropdownButton from "../../../../components/dropdown/DropdownButton";
import CommonDropdown from "../../../../components/dropdown/CommonDropdown";
import { AppContext } from "../../../../contexts/AppContext";
import CommonsHelper from "../../../../helpers/CommonsHelper";
import CommonSwal from "../../../../components/Swal/commonSwal";
import { formataData } from "../../../../helpers/mesesHelper";
import Format from "../../../../helpers/Format";
import PropTypes from "prop-types";

function MensalidadeDataTable({ linhas, togSubstituirHonorarioModal }) {
  const { session } = React.useContext(AppContext);

  const colunas = React.useMemo(
    () => [
      {
        Header: "Mês de referência",
        accessor: "mes_referencia",
        disableSortBy: true,
      },
      {
        Header: "Vencimento",
        disableSortBy: true,
        accessor: (row) => {
          return formataData(row.data_vencimento);
        },
      },
      {
        Header: "Valor",
        disableSortBy: true,
        accessor: (row) => {
          return Format.formataValor(row.valor_liquido ?? 0);
        },
      },
      {
        Header: "Status",
        disableSortBy: true,
        Cell: ({ row }) => {
          let status = [];
          var data_vencimento = new Date(row.original.data_vencimento);
          var dia_atual = new Date();
          data_vencimento.setDate(data_vencimento.getDate() + 1);

          if (
            row.original.valor_pago === null ||
            row.original.valor_pago === ""
          ) {
            if (dia_atual < data_vencimento) {
              status.push(
                <div>
                  <Badge color="warning">Pendente</Badge>
                </div>
              );
            } else {
              status.push(
                <div>
                  <Badge color="danger">Vencido</Badge>
                </div>
              );
            }
          } else {
            status.push(
              <div>
                <Badge color="success">Pago</Badge>
              </div>
            );
          }

          return (
            <div>
              <div className="mb-2" role="group">
                {status}
              </div>
            </div>
          );
        },
      },
      {
        Header: "Ações",
        disableSortBy: true,
        Cell: ({ row }) => {
          var status = [];

          status.push(
            <>
              <DropdownButton
                key={`visualizar-${row.original.id}`}
                onClick={() => {
                  window.open(row.original.caminho, "_blank");
                }}
                color="primary"
                icon="mdi mdi-file-search"
              >
                Visualizar
              </DropdownButton>
              <DropdownButton
                key={`copiar-codigo-${row.original.id}`}
                onClick={() => {
                  CommonsHelper.copiarConteudo(
                    row.original.linha_digitavel
                  ).then(() => {
                    CommonSwal({
                      title: "Código de barras copiado",
                      icon: "success",
                    });
                  });
                }}
                color="warning"
                icon="mdi mdi-barcode"
              >
                Copiar código de barras
              </DropdownButton>
            </>
          );

          if (
            parseInt(session?.codigo) >= 10 &&
            (row.original.valor_pago === null ||
              row.original.valor_pago === "") &&
            row.original.tipo === "COBRE"
          )
            status.push(
              <DropdownButton
                key={`substituir-${row.original.id}`}
                onClick={() => {
                  togSubstituirHonorarioModal(row.original.id);
                }}
                color="info"
                icon="mdi mdi-file-replace"
              >
                Substituir
              </DropdownButton>
            );

          return <CommonDropdown>{status}</CommonDropdown>;
        },
      },
    ],
    [session?.codigo, togSubstituirHonorarioModal]
  );

  return <CommonDataTable colunas={colunas} linhas={linhas} />;
}

MensalidadeDataTable.propTypes = {
  linhas: PropTypes.array.isRequired,
  togSubstituirHonorarioModal: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default MensalidadeDataTable;
